import { Box } from "@mui/material";

export function Grow()
{
	return <Box sx={{ flexGrow: 1 }} />
}